<!--
 * @Author: likk 1126919170@qq.com
 * @Date: 2024-05-09 14:49:22
 * @LastEditors: likk 1126919170@qq.com
 * @LastEditTime: 2024-05-13 15:06:30
 * @FilePath: /m-ai.nongji360.com/src/views/Spark/components/InfoFeedback.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<van-popup class="pop-info" v-model="show"  round  position="bottom" :close-on-click-overlay="false">
		<div class="top">
			<span class="tit">信息反馈</span>
			<van-icon class="icon-close" name="cross" @click="handleClose()" />
		</div>
		<van-checkbox-group class="checkbox-group" v-model="checkedIds" checked-color="#7FBE26">
			<template v-if="infoFeedback.type==1">
				<van-checkbox v-for="(item,index) in laudCheckboxList" :key="index" shape="square" :name="item.id">{{item.title}}</van-checkbox>
			</template>
			<template v-if="infoFeedback.type==2">
				<van-checkbox v-for="(item,index) in caiCheckboxList" :key="index" shape="square" :name="item.id">{{item.title}}</van-checkbox>
			</template>
		</van-checkbox-group>
		<van-field	v-model="remark"	type="textarea"	placeholder="留下更多反馈"	rows="2"/>
		<div class="btn-submit" @click="handleSubmit()">提交反馈</div>
	</van-popup>
</template>

<script>
	export default {
		props:{
			infoFeedback:{
				type:Object,
				default:{
					id:"",
					answerId:"",
					type:1,
					
				}
			}
		},
		data(){
			return {
				show:true,
				checkedIds:[],
				remark:"",
				laudCheckboxList:[],
				caiCheckboxList:[]
			}
		},
		created(){
			this.getInformation();
		},
		methods: {
			async getInformation(){
				const {like,stepOn} = await this.$http.spark.getInformationList();
				this.laudCheckboxList = like;
				this.caiCheckboxList = stepOn;
			},
		/**
			* @description: 提交数据
			* @return {*}
			*/			
			async handleSubmit(){
				if(!this.checkedIds.length && !this.remark){
					this.$toast("请选择反馈内容或者填写反馈内容");
					return false;
				}
				const result = await this.$http.spark.saveInfromation({
					...this.infoFeedback,
					selectId:this.checkedIds.join(","),
					remark:this.remark
				});
				if(result==1){
					this.handleClose();
				}
			},
			/**
				* @description: 关闭弹框
				* @return {*}
			*/
			handleClose(){
				this.$emit("close");
			}
		}
	}
</script>

<style lang="scss" scoped>
	.pop-info{
		box-sizing: border-box;
		padding: 0 15px;
		background: linear-gradient(180deg, #F2F8EA 0%, #FFFFFF 100%);
		.top{
			padding: 13px 0;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.tit{
				font-size: 17px;
				color: #323333;
			}
			.icon-close{
				font-size: 22px;
				color: #CFCFCF;
			}
		}
		
		::v-deep .van-checkbox{
			margin-bottom: 10px;
			.van-checkbox__icon{
				font-size: 15px;
			}
			.van-checkbox__label{
				font-size: 15px;
				color: #666666;
			}
		}
		.van-field{
			background-color: transparent;
			border-radius: 3px;
			border: 1px solid #dcdcdc;
			padding: 6px 7px;
			font-size: 14px;
		}
		.btn-submit{
			width: 100%;
			height: 48px;
			line-height: 48px;
			text-align: center;
			background: #7FBE26;
			border-radius: 24px;
			font-size: 16px;
			color: #ffffff;
			margin: 14px auto;
		}
	}
</style>